<template>
  <!-- 编辑地址页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="修改地址" left-arrow @click-left="$router.back()" />
    </div>
    <div class="center">
      <van-address-edit
        :address-info="addressinfo"
        show-set-default
        show-search-result
        :show-area="false"
        :show-detail="false"
        @save="onSave"
        :value="addressinfo.areaCode"
        :tel-validator="validator"
      >
        <template #default>
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="地区"
            placeholder="请选择所在地区"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="options"
              @change="onChange"
              @close="show = false"
              @finish="onFinish"
            />
          </van-popup>
          <van-field
            v-model="detailedAddress"
            label="详细地址"
            placeholder="街道门牌、楼层房间号等信息"
          />
        </template>
      </van-address-edit>
      <van-button type="default" @click="onDelete" class="delete"
        >删除</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addressID: "",
      addressinfo: {
        id: "",
        name: "",
        tel: "",
        addressDetail: "",
        county: "",
        isDefault: false,
      },
      province: "",
      city: "",
      county: "",
      street: "",
      show: false,
      fieldValue: "",
      cascaderValue: "",
      detailedAddress: "",
      options: [],
    };
  },
  created() {
    this.getcity();
    this.getProvince();
  },
  methods: {
    validator(e) {
      let myreg1 = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg1.test(e)) {
        return false;
      } else {
        return true;
      }
    },
    // 修改保存的事件
    async onSave(content) {
      this.addressID = this.$route.query.id;
      if (content.isDefault == true) {
        sessionStorage.setItem("_ADDRESS", this.$route.query.id);
      }
      await this.$post({
        url: "/omsConsigneeAddress/updAddress",
        method: "post",
        params: {
          id: this.addressID,
          mobile: content.tel,
          consignee: content.name,
          province: this.province,
          city: this.city,
          district: this.county,
          street: this.street,
          address: this.detailedAddress,
          firstChoice: content.isDefault == true ? 1 : 0,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.$toast.success("修改成功");
            this.$router.back();
            this.street = "";
            this.province = "";
            this.city = "";
            this.county = "";
            content.name = "";
            content.tel = "";
            content.isDefault = false;
          }
        })
        .catch((err) => {
          this.$toast("修改失败");
        });
    },
    // 删除地址的事件
    async onDelete(content) {
      this.addressID = this.$route.query.id;
      this.$dialog
        .confirm(
          await {
            title: "提示",
            message: "您确定要删除吗？",
          }
        )
        .then(() => {
          this.$post({
            url: "/omsConsigneeAddress/delAddressById",
            method: "post",
            params: {
              id: this.addressID,
              userId: sessionStorage.getItem("EXCLUSIVE"),
            },
          })
            .then((res) => {
              this.$router.back();
              sessionStorage.removeItem("_ADDRESS");
              sessionStorage.removeItem("AREA");
              this.$toast("已删除");
            })
            .catch((err) => {
              this.$toast("删除失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 获取地址详细信息
    async getcity() {
      this.addressID = this.$route.query.id;
      this.$post({
        url: "/omsConsigneeAddress/findAddressById",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          id: this.addressID,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            let field = res.data.code;
            this.addressinfo.name = field.consignee;
            this.addressinfo.tel = field.mobile;
            this.detailedAddress = field.address;
            this.province = field.province;
            this.city = field.city;
            this.county = field.district;
            this.addressinfo.isDefault = field.first_choice == 1 ? true : false;
            if (field.regionNameS) {
              this.fieldValue =
                field.regionNameP +
                field.regionNameC +
                field.regionNameD +
                field.regionNameS;
              this.street = field.street;
            } else {
              this.fieldValue =
                field.regionNameP + field.regionNameC + field.regionNameD;
            }
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.province = selectedOptions[0].value;
      this.city = selectedOptions[1].value;
      this.county = selectedOptions[2].value;
      if (selectedOptions.length == 4) {
        this.street = selectedOptions[3].value;
      } else {
        this.street = "";
      }
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    // 点击获取市、区、镇级数据
    onChange({ value }) {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
        params: {
          parentId: value,
        },
      }).then((res) => {
        if (res.retCode == 200) {
          if (res.data.code.length == 0) {
            return false;
          } else {
            // 市级数据
            if (res.data.code[0].level == 2) {
              this.options.forEach((element) => {
                element.children = [];
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  if (element.value == item.parent_id) {
                    element.children.push({
                      text: item.name,
                      value: item.id,
                      children: [],
                    });
                  }
                });
              });
              // 区/县级数据
            } else if (res.data.code[0].level == 3) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children = [];
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    if (element2.value == item.parent_id) {
                      if (item.childCount == 0) {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                        });
                      } else {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                          children: [],
                        });
                      }
                    }
                  });
                });
              });
              // 镇/街道级数据
            } else if (res.data.code[0].level == 4) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children.forEach((element3) => {
                    element3.children = [];
                  });
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    element2.children.forEach((element3) => {
                      element3.children.push({
                        text: item.name,
                        value: item.id,
                      });
                    });
                  });
                });
              });
            }
          }
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 获取省级数据
    getProvince() {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
          this.options = [].concat(...this.options);
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgba(245, 245, 245, 1);
  overflow: hidden;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #f8f8f8;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
          vertical-align: middle;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    margin: 1rem 0.27rem 0 0.27rem;
    background-color: #1f000000;
    padding-top: 0.83rem;
    .van-checkbox {
      background-color: #ffffff;
      border-radius: 0.21rem;
      margin-bottom: 0.27rem;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        display: none;
      }
    }
    .van-address-edit {
      /deep/.van-address-edit__buttons {
        padding-bottom: 0 !important;
      }
    }
    .delete {
      display: block;
      width: 8.8rem;
      height: 1.33rem;
      margin: 0 auto;
      border-radius: 5rem;
      // border: 1px solid #ffffff;
    }
  }
}
</style>
